import { FC, useRef, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { observer } from 'mobx-react'
import { useStores } from '@/utils'
import {
  IUserBase,
  IUserReferenceBase,
  // MessageType,
  UserReferenceStatus,
} from '@/types'
import { UserReferenceCard } from '@components-v2/molecules/UserReferenceCard'
import { UserReferenceForm } from '@/components/molecules/UserReferenceForm'
import { ProfileCardListGrid } from '@components-v2/organisms/ProfileCardListGrid'
import { NoContent } from '@components-v2/atoms/NoContent'
import styles from './index.module.scss'

type Props = {
  user: IUserBase
}

// TODO v2 デザインに編集削除がないので後で追加する。一旦Figma にあるものを表示するだけ
export const UserReferenceGroup: FC<Props> = observer(({ user }) => {
  const { t } = useTranslation(['p'])
  const {
    // messages,
    viewer,
  } = useStores()
  const [references, setReferences] = useState<IUserReferenceBase[]>(user.userReferences?.nodes)
  const [editingReference, setEditingReference] = useState<IUserReferenceBase>(null)
  const newFormRef = useRef<HTMLDivElement>()
  // const scroll = () => newFormRef.current.scrollIntoView({ behavior: 'smooth' })
  const viewerComment = references.find((r) => r.commenter.username === viewer.viewer?.username)
  const commentable = viewerComment
    ? viewerComment.status === UserReferenceStatus.SHOWN && editingReference
    : user.username !== viewer.viewer?.username
  const hiddenReferences = user.userReferences?.nodes?.filter((r) => r.status === UserReferenceStatus.HIDDEN)

  // const onClickDelete = async (id: string) => {
  //   // eslint-disable-next-line no-alert
  //   if (window.confirm(t('応援コメントを削除しますか？'))) {
  //     const isSuccessful = await viewer.viewer.removeUserReference(id)
  //     if (isSuccessful) {
  //       setReferences(references.filter((r) => r.id !== id))

  //       messages.add({
  //         type: MessageType.Info,
  //         body: t('応援コメントを削除しました'),
  //         isTranslated: true,
  //         ttl: 5000,
  //       })
  //     }
  //   }
  // }

  // const onClickEdit = (reference: IUserReferenceBase) => {
  //   setEditingReference(reference)
  //   setTimeout(() => scroll(), 30)
  // }

  return (
    <div className={styles.container}>
      {references.length === 0 || references.length === hiddenReferences.length ? (
        <NoContent>
          <p>{t('応援コメントがまだありません。')}</p>
          <p>
            {t('応援コメントを書くと、この人物の第三者評価となり、投資活動、転職活動、PRなどの加速に協力できます。')}
          </p>
        </NoContent>
      ) : (
        <ProfileCardListGrid>
          {references.map((reference) => {
            // const haveEditAndDelete = reference.commenter.username === viewer.viewer?.username
            // hide の場合表示
            if (reference.status === UserReferenceStatus.HIDDEN) {
              return null
            }

            return (
              <UserReferenceCard
                key={reference.id}
                item={reference}
                // onClickEdit={onClickEdit}
                // onClickDelete={onClickDelete}
                // isTwoColumn
                // haveEditAndDelete={haveEditAndDelete}
              />
            )
          })}
        </ProfileCardListGrid>
      )}

      {viewer.isInitialized && viewer.isSignedIn && commentable && (
        <div ref={newFormRef}>
          <UserReferenceForm
            reference={editingReference}
            references={references}
            setReferences={(newReference: IUserReferenceBase[]) => setReferences(newReference)}
            setEditingReference={(targetReference: IUserReferenceBase) => setEditingReference(targetReference)}
          />
        </div>
      )}
    </div>
  )
})
